import React, { Component } from "react";
import "./header.scss";

export default class Header extends Component {
  render() {
    let resumeData = this.props.resumeData;
    return (
      <React.Fragment>
        <header id="home">
          <nav id="nav-wrap">
            <a className="mobile-btn" href="#nav-wrap" title="Show navigation">
              Nawigacja włączona
            </a>
            <a className="mobile-btn" href="#home" title="Hide navigation">
              Nawigacja wyłączona
            </a>
            <ul id="nav" className="nav">
              <li className="current">
                <a className="smoothscroll" href="#home">
                  początek
                </a>
              </li>
              <li>
                <a className="smoothscroll" href="#about">
                  o mnie
                </a>
              </li>
              <li>
                <a className="smoothscroll" href="#resume">
                  cv
                </a>
              </li>
              <li>
                <a className="smoothscroll" href="#portfolio">
                  portfolio
                </a>
              </li>
              <li>
                <a className="smoothscroll" href="#testimonials">
                  umiejętności
                </a>
              </li>
              <li>
                <a className="smoothscroll" href="#contact">
                  kontakt
                </a>
              </li>
            </ul>
          </nav>

          <div className="row banner">
            <div className="banner-text">
              <h1
                className="responsive-headline"
                style={{ fontFamily: "Roboto" }}
              >
                {resumeData.name}
              </h1>
              <h3 style={{ color: "#fff", fontFamily: "sans-serif " }}>
                {resumeData.role}
              </h3>
              <h3 style={{ color: "#fff", fontFamily: "sans-serif " }}>
                {resumeData.roleDescription}
              </h3>
              <hr />
              <ul className="social">
                {resumeData.socialLinks &&
                  resumeData.socialLinks.map(item => {
                    return (
                      <li key={item.name}>
                        <a
                          href={item.url}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className={item.className} />
                        </a>
                      </li>
                    );
                  })}
              </ul>
            </div>
          </div>

          <p className="scrolldown">
            <a className="smoothscroll" href="#about">
              <i className="icon-down-circle" />
            </a>
          </p>
        </header>
      </React.Fragment>
    );
  }
}
